export const servita = {
	nombre: "Servita",
	dia: "Viernes de Dolores",
	nombrecompleto:
		"Venerable Orden Tercera de Servitas Esclavos de María Santísima de los Dolores Coronada",
	sede: "Parroquia de San Lorenzo Diácono y Mártir",
	pasos: 1,
	distancia: [739, 821],
	penitentes: 110,
	cargadores: 56,
	web: 'http://www.diariodecadiz.es/semana_santa/Servitas_0_1229277767.html',
	ida: [
		{ lng: -6.3004097, lat: 36.5316054 },
		{ lng: -6.3003454, lat: 36.5315774 },
		{ lng: -6.3005573, lat: 36.5312455 },
		{ lng: -6.3013083, lat: 36.5314804 },
		{ lng: -6.300914, lat: 36.5320925 },
		{ lng: -6.3001415, lat: 36.5318619 },
		{ lng: -6.2988822, lat: 36.5313446 },
		{ lng: -6.2982391, lat: 36.5311119 },
		{ lng: -6.2975961, lat: 36.5309265 },
		{ lng: -6.2975639, lat: 36.5310041 },
		{ lng: -6.2971777, lat: 36.5308726 },
		{ lng: -6.2967512, lat: 36.530836 },
		{ lng: -6.2963301, lat: 36.5306054 },
		{ lng: -6.2956528, lat: 36.5299184 },
		{ lng: -6.2950847, lat: 36.5294964 },
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2955844, lat: 36.529088 },
		{ lng: -6.2956917, lat: 36.5291225 },
		{ lng: -6.2954235, lat: 36.529767 },
		{ lng: -6.2955426, lat: 36.5298682 },
		{ lng: -6.2956544, lat: 36.529956 },
		{ lng: -6.2952848, lat: 36.5303552 },
		{ lng: -6.2950748, lat: 36.5307067 },
		{ lng: -6.2950158, lat: 36.5308403 },
		{ lng: -6.2949702, lat: 36.5314696 },
		{ lng: -6.2963972, lat: 36.5317628 },
		{ lng: -6.2967977, lat: 36.5325461 },
		{ lng: -6.2969765, lat: 36.532808 },
		{ lng: -6.2971549, lat: 36.5326992 },
		{ lng: -6.2973828, lat: 36.5325548 },
		{ lng: -6.2985288, lat: 36.533002 },
		{ lng: -6.2998303, lat: 36.5321172 },
		{ lng: -6.3004097, lat: 36.5316054 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-23T19:00",
			latlng: [36.5316, -6.3004]
		},
		{
			name: "Catedral",
			hora: "2018-03-23T21:15",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-23T22:15",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-23T22:45",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Gaspar del Pino",
			hora: "2018-03-23T23:20",
			latlng: [36.53264, -6.29761]
		}
	],
	itinerario: [
		[
			"Sagasta (dcha.)",
			"Mateo de Alba",
			"San José (dcha.)",
			"Hospital de Mujeres (dcha.)",
			"Plaza la Libertad",
			"Plaza Topete",
			"Compañía",
			"Plaza de Pio XII",
			"Arquitecto Acero",
			"Estación de Penitencia en la S.I.C"
		],
		["Plaza Pío XII", "Compañía", "Santiago", "Plaza Candelaria"],
		["Montañés", "Plaza Palillero"],
		["Novena", "San Miguel", "Gaspar del Pino"],
		["Benjumeda", "Sagasta (izq.)", "A su templo"]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/servita.js